// Styles and small helpers the recipe writing steps share (slice 7b), kept
// apart from the components so hot reload keeps working.
import type { CSSProperties } from "react";
import { COLORS, FONT_SIZE, LAYOUT, RADIUS } from "../../lib/constants";
import type { Recipe } from "../../lib/types";
import { inputStyle } from "../plan/planStyles";

export const primaryButton: CSSProperties = { minHeight: LAYOUT.tapTarget, border: "none", borderRadius: RADIUS.md, padding: "0 var(--space-xxl)", background: COLORS.accent, color: COLORS.onAccent, fontSize: FONT_SIZE.base, fontWeight: 700, cursor: "pointer" };
export const secondaryButton: CSSProperties = { ...primaryButton, background: "transparent", color: COLORS.accent, border: `1px solid ${COLORS.accent}` };
export const fieldInput: CSSProperties = { ...inputStyle, width: "100%" };
export const stepHeading: CSSProperties = { margin: 0, fontFamily: "var(--font-serif)", fontSize: FONT_SIZE.h2, fontWeight: 600, lineHeight: 1.2 };

export const isYieldType = (r: Pick<Recipe, "recipeType">) => r.recipeType === "preserves" || r.recipeType === "medicinal";

// The sections used, in order of first appearance.
export const sectionsIn = (rows: { component: string }[]) => [...new Set(rows.map((r) => r.component).filter(Boolean))];
